<template>
  <div>
    <folders-list-file-and-folder></folders-list-file-and-folder>
  </div>
</template>

<script>
import FoldersListFileAndFolder from "@/components/folders/folders-list-file-and-folder";
import {mapMutations} from "vuex";
export default {
  name: "folders-payments-detail",
  components: {FoldersListFileAndFolder},
  methods: {
    ...mapMutations(['setNameSectionFolders']),
  },
  mounted() {
    if(this.$route.path.indexOf('vessels') === -1) {
      this.setNameSectionFolders('Payments')
    } else {
      this.setNameSectionFolders('Vessels')
    }
  }
}
</script>

<style scoped>

</style>